import { ContainerModule } from '@yandex-int/k-common/typings';
import b from 'b_';
import { BackgroundImage, H3, Text } from 'platform-components';
import { useWidthBreakpoints, WidthBreakpoints } from 'platform-components/src/utils/hooks/useWidthBreakpoints';
import React, { useRef } from 'react';

import { CourseContainerLessonsPromo } from '../__lesson-promo/course-container__lesson-promo';

import './course-container__module-card.scss';

interface Props {
    containerModule: ContainerModule;
    openModuleOrder: number;
    openModuleOrderFromActiveGroup: number;
}

const BREAKPOINTS: WidthBreakpoints<boolean> = [
    [true, 812],
    [false, 0],
];

export const CourseContainerModuleCard = ({
    containerModule,
    openModuleOrder,
    openModuleOrderFromActiveGroup,
}: Props) => {
    const { color: moduleColor, cover: moduleCover, cover_background_color: moduleCoverColor } = containerModule.module;

    const coverStyle = {
        backgroundColor: moduleCoverColor ? moduleCoverColor : undefined,
    };

    const hatStyle = {
        backgroundColor: moduleColor ? moduleColor : undefined,
    };

    const ref = useRef<HTMLDivElement>(null);
    const showCover = useWidthBreakpoints(ref, BREAKPOINTS, false);

    return (
        <div className={b('course-container', 'module-card')} ref={ref}>
            <div className="course-container__module-card-hat" style={hatStyle} />
            {showCover && (
                <div className="course-container__module-card-image-wrapper" style={coverStyle}>
                    <BackgroundImage
                        mix="course-container__module-card-image"
                        objectFit="contain"
                        objectPosition="left center"
                        src={moduleCover}
                    />
                </div>
            )}
            <div className="course-container__module-card-content">
                <div className="course-container__module-card-subtitle-wrapper">
                    <Text className="course-container__module-card-subtitle" size={Text.SIZE.XL}>
                        {containerModule.group_name}
                    </Text>
                </div>
                <div className="course-container__module-card-title">
                    <H3
                        weight={Text.WEIGHT.M}
                    >{`${openModuleOrder}.${openModuleOrderFromActiveGroup} ${containerModule.module.name}`}</H3>
                </div>
                <div className="course-container__module-card-annotation">
                    <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN}>
                        {containerModule.module.annotation}
                    </Text>
                </div>
                <CourseContainerLessonsPromo module={containerModule.module} />
            </div>
        </div>
    );
};
